export default __webpack_public_path__ + "static/media/spoon.0d32cbc7.png";